import { render, staticRenderFns } from "./BuildingStoreysAddView.vue?vue&type=template&id=971fee64&scoped=true&"
import script from "./BuildingStoreysAddView.vue?vue&type=script&lang=js&"
export * from "./BuildingStoreysAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971fee64",
  null
  
)

export default component.exports